import { createBrowserRouter, Navigate } from "react-router-dom";
import AddOrEditProductPage from "../components/admin/AddOrEditProductPage";
import AdminDashboard from "../components/admin/AdminDashboard";
import ResponsiveAdminInventory from "../components/product/ResponsiveAdminInventory";
import AdminHeader from "../pages/AdminHeader";
import CategoriesManagement from "../pages/CategoriesManagement";
import Customers from "../pages/Customers";
import DeliveryChargesManagement from "../pages/DeliveryChargesManagement";
import EditStoreConfig from "../pages/EditStoreConfig";
import HomePage from "../pages/HomePage";
import { LoginPage } from "../pages/LoginPage";
import { OnboardingPage } from "../pages/OnboardingPage";
import OrderManagement from "../pages/OrdersManagement";
import OrderDetail from "../pages/OrderDetail";
import PaymentMethods from "../pages/PaymentMethods";
import Settings from "../pages/Settings";
import StoreConfig from "../pages/StoreConfig";

const router = createBrowserRouter([
  {
    path: "",
    element: <HomePage />,
  },
  {
    path: "login",
    element: <LoginPage />,
  },
  {
    path: "onboarding",
    element: <OnboardingPage />,
  },
  {
    path: "admin",
    element: <AdminHeader />,
    children: [
      { path: "", element: <AdminDashboard /> },
      { path: "products", element: <ResponsiveAdminInventory /> },
      { path: "add-product", element: <AddOrEditProductPage /> },
      { path: "orders", element: <OrderManagement /> },
      { path: "orders/:orderId", element: <OrderDetail /> },
      { path: "customers", element: <Customers /> },
      { path: "categories", element: <CategoriesManagement /> },
      { path: "store", element: <StoreConfig /> },
      { path: "store/edit", element: <EditStoreConfig /> },
      { path: "settings", element: <Settings /> },
      { path: "payments", element: <PaymentMethods /> },
      { path: "delivery-charges", element: <DeliveryChargesManagement /> },
    ]
  },
  {
    path: "*",
    element: <Navigate to="/" replace />
  }
]);

export default router;
